var React = require('react');

import ProgressBar from '../common/_ProgressBar.jsx';
import {CustomAlert, onEscapePress}	from '../common/_Utilities.jsx';
import blSecurity					from '../utils/_security.jsx';

var mocViewer;

export default class ModelViewer extends React.Component {
	constructor(props){
		super(props);

		this.state = {
			viewType: props.viewType, /* steps, model */
			modelLoaded: false,
			nSteps: 0,
			currentStep:0,
			highlightedBrickKey: '',
			progress: 0,
			showPagePreview: false,
			isFullScreen: false
		}
	}

	componentDidMount() {
		this.init(this.props.idModel);
		this.setState({modelLoaded: true});
		onEscapePress(() => this.props.func.closeModal());
	}


	componentDidUpdate(prevProps, prevState) {
		if(prevState.isFullScreen != this.state.isFullScreen) {
			mocViewer.onWindowResize();
		}
		
		onEscapePress(() => this.props.func.closeModal());
	}

	render() {
		return (
			<div className="modal">
				<div className="modal__overlay" onClick={() => this.props.func.closeModal()}></div>
				<div className={"modal__content moc-viewer__modal-content" + (this.state.showPagePreview ? ' moc-viewer__modal-content--steps-overview-open' : '') + (this.state.isFullScreen ? ' moc-viewer__modal-content--fullscreen' : '')}>
					<div className="modal__header">
						<div className="modal__title">{this.props.modelInfo.strModelName}</div>
						<i className="far fa-times modal__close" onClick={() => this.props.func.closeModal()}></i>
					</div>
				
					{/* Main viewer */}
					<div className={"modal__body moc-viewer__modal-body l-pad-null" + (this.state.progress > 0 && this.state.progress < 100 ? ' moc-viewer__modal-body--loading' : '') + (this.state.showPagePreview && this.state.showSubModel ? '' : this.state.showSubModel ? ' l-relative' : '')}>
						{/* Submodel image should be show inside the main viewer */}
						{this.state.showSubModel ?
							<div className="moc-viewer__moc-submodel">
								<img src={this.state.subModelImage} className="l-block"/>
								{this.state.subModelCnt > 1 ? <span className="moc-viewer__moc-submodel-count">{this.state.subModelCnt}</span> : null}
							</div>
						: null}
						<div className="moc-viewer__stage-container">
							<div id="container" className="moc-viewer__stage"/>
							{this.renderLegend()}
							
							{this.state.viewType == 'steps' ?
								<div className="moc-viewer__pagination">
									<button className="moc-viewer__pagination-item moc-viewer__pagination-item--prev" onClick={() => this.showPreviousPage()}>
										<i className="fas fa-chevron-left"/>
									</button>
									<button className="moc-viewer__pagination-item moc-viewer__pagination-item--next" onClick={() => this.showNextPage()}>
										<i className="fas fa-chevron-right"/>
									</button>
								</div>
							: null}
						</div>
						{/* Progress Information. Show progger info in an overlay as it is now in classic? */}
						{this.state.progress > 0 && this.state.progress < 100 ?
							<div className="moc-viewer__progress">
								<div className="l-margin-bottom">Fetching Bricks...</div>
								<ProgressBar classes="moc-viewer__progress-bar" progress={parseInt(this.state.progress)} clean={true}/>
							</div>
						: null}

						{this.state.viewType == 'steps' ?
							<div className="moc-viewer__steps">
								<button id="navigator_pages" className="btn btn--tight btn--cta-outline text--bold l-margin-bottom" disabled={this.state.progress > 0 && this.state.progress < 100} onClick={() => this.showNavigatorPage()}>
								  <i className="fas fa-th l-margin-right--sm" aria-hidden="true"/>Step {this.state.currentStep}/{this.state.nSteps}
								</button>
								<div id="container_palette" className="moc-viewer__parts">
									{this.state.partsArray}
								</div>
							</div>
						: null}
						{this.state.showPagePreview ? 
							<PagePreview mocViewer={mocViewer} closePagePreview={this.closeNavigatorPage} updateBrickPalette={this.updateBrickPalette} closeModal={() => this.props.func.closeModal()}/>
						: null}
					</div>
						
				</div>
			</div>
		)
	}

	renderLegend() {
		return (
			<div className={"moc-viewer__legend " + (this.state.viewType == '3d' ? 'moc-viewer__legend--3d' : '')}>
				<ul className="moc-viewer__gestures">
					<li className="moc-viewer__gestures-item">
						<div className="l-flex l-center l-hide--small">
							<img className="moc-viewer__gestures-image" src={"//" + blapp.config.getHost( "static2" ) + "/img/moc-modal/icon-rotate-desk.svg"} alt="Hold left click to rotate"/>
							<span className="l-margin-left--sm">Rotate</span>
						</div>
						<div className="l-flex l-center l-hide--desktop">
							<img className="moc-viewer__gestures-image" src={"//" + blapp.config.getHost( "static2" ) + "/img/moc-modal/icon-rotate-mobile.svg"} alt="Single fingure touch to rotate"/>
							<span className="l-margin-left--sm">Rotate</span>
						</div>
					</li>
					<li className="moc-viewer__gestures-item">
						<div className="l-flex l-center l-hide--small">
							<img className="moc-viewer__gestures-image moc-viewer__gestures-image--desktop" src={"//" + blapp.config.getHost( "static2" ) + "/img/moc-modal/icon-pan-desk.svg"} alt="Hold right click to pan"/>
							<span className="l-margin-left--sm">Pan</span>
						</div>
						<div className="l-flex l-center l-hide--desktop">
							<img className="moc-viewer__gestures-image moc-viewer__gestures-image--mobile" src={"//" + blapp.config.getHost( "static2" ) + "/img/moc-modal/icon-pan-mobile.svg"} alt="Two fingure touch to pan"/>
							<span className="l-margin-left--sm">Pan</span>
						</div>
					</li>
					<li className="moc-viewer__gestures-item">
						<div className="l-flex l-center l-hide--small">
							<img className="moc-viewer__gestures-image moc-viewer__gestures-image--desktop" src={"//" + blapp.config.getHost( "static2" ) + "/img/moc-modal/icon-zoom-desk.svg"} alt="Scroll mouse wheel to zoom"/>
							<span className="l-margin-left--sm">Zoom</span>
						</div>
						<div className="l-flex l-center l-hide--desktop">
							<img className="moc-viewer__gestures-image moc-viewer__gestures-image--mobile" src={"//" + blapp.config.getHost( "static2" ) + "/img/moc-modal/icon-zoom-mobile.svg"} alt="Pinch to zoom"/>
							<span className="l-margin-left--sm">Zoom</span>
						</div>
					</li>
				</ul>
				<button className="btn btn--blank moc-viewer__full-screen-trigger l-hide--small" onClick={() => this.setState({isFullScreen: !this.state.isFullScreen})}><i className={"text-color--border l-margin-right--sm fas " + (this.state.isFullScreen ? 'fa-compress-alt' : 'fa-expand-alt')}/>{this.state.isFullScreen ? 'Exit' : 'Enter'} fullscreen</button>
			</div>
		);
	}

	showSubModelImage = (flag, imageUrl) => {
		if(flag==true){
			this.setState({ 
				showSubModel : true,
				subModelImage: imageUrl 
			})
		}
		else
			this.setState({ showSubModel : false })
	}

	triggerAlert(message) {
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom"></i>
		<p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent);
	}

	loadModel()
	{
		let type = this.props.modelInfo.type ? this.props.modelInfo.type : 'gallery';
		blapp.models.fetch(
			"_serverTime",
			{
				refresh: true,
				controller: "common.BLCSystemData",
				method: "getServerTime",
				params:	[]
			}
		).then((ts) => {
			let data = {idModel: this.props.idModel, ts: ts, type: type };
			data = blSecurity.encrypt(data);
			mocViewer.loadModelByUrl(
				`/_file/studio/modelView.file?k=${data}`, {}, 
				() => {
					if(this.state.viewType == 'steps'){
						this.startStepView();
					} 	
				}, 
				(msg) => {
					this.props.func.closeModal();
					this.triggerAlert(msg);
				}
			);
		}
		).catch(() => {
			this.triggerAlert("Error loading model")
		}
		);
	}

	init() {
		if (!Detector.webgl) {
			this.triggerAlert("no webgl");
			return;
		}
	
		mocViewer = new MOCViewer();

		//mocViewer.startBuildingCallback = this.startBuilding;

		mocViewer.updateBrickPaletteCallback = this.updateBrickPalette;
	
		mocViewer.updatePageDisplay = this.updatePageDisplay;
	
		mocViewer.highlightBrickCallback = this.highlightBrick
	
		// mocViewer.pageChangeCallback = function(newIdx, oldIdx, pageManager){
		// 	updatePageNavigator(newIdx, oldIdx, pageManager);
		// }
		
		mocViewer.subModelPageCallback = this.showSubModelImage;

		mocViewer.init("/files/renovate/blstudio/blstudioModelParts.file?idPart=", this.renderModel, document
				.getElementById("container"), {
			width : "128",
			height : "128"
		}, document.getElementById("popUpDlg"), document.getElementById("container_palette"));
		
		SB_BRIGL.progress = (msg, value) => {
			this.setState({progress: value})
		}

		this.loadModel();
	}

	renderModel() {
		if (mocViewer)
		mocViewer.render();
	}

	updatePageDisplay = () => {
		this.setState({
			nSteps : mocViewer.pageManager.pageList.length-1,
			currentStep: mocViewer.pageManager.currentPageIndex
		})
	}

	showPreviousPage()
	{
		mocViewer.showPrevPage();
	}

	showNextPage()
	{
		mocViewer.showNextPage();
	}

	showNavigatorPage()
	{
		this.setState({ showPagePreview: true })	
	}

	closeNavigatorPage = () =>
	{
		this.setState({
			showPagePreview: false,
			previewArray: []
		})
	}

	startStepView = () =>
	{
		if (typeof mocViewer == "undefined")
		{
			return;
		}

		if(mocViewer.isLoadCompleted==false){
			return;
		}
		if(mocViewer.isStartBuilding){
			return;
		}
		mocViewer.startBuilding();
	}

	updateBrickPalette = () => 
	{			
		var currentBrickPaletteInfoList = mocViewer.currentBrickPaletteInfoList;
		var partsMultiplier = mocViewer.getCurrentPagePartsMultiplier();

		this.setState({ 
			highlightedBrickKey: "",
			partsArray: [],
			subModelCnt: partsMultiplier
		});
		
		if(currentBrickPaletteInfoList.length==0){
			return;
		}

		let parts = []
		for (var i = 0; i < currentBrickPaletteInfoList.length; i++) {
			var brickCnt = currentBrickPaletteInfoList[i].cnt;
			var key = currentBrickPaletteInfoList[i].key;
			var isSubmodel = currentBrickPaletteInfoList[i].isSubmodel;

			parts.push(<ModelPart
				src={mocViewer.imageURLList[key]!==undefined ? mocViewer.imageURLList[key]: ''}
				name = {key}
				isSubmodel = {isSubmodel}
				brickCnt = {brickCnt}
				stepInfo = {mocViewer.stepInfoList[key]}
				key = {key}
				onClick = {this.highLightOnClick}
			/>)
		}
		this.setState({ partsArray : parts })
		setTimeout(this.loadImageForBrickPalette, 1);
	}

	loadImageForBrickPalette = () => 
	{
		var keys = [];
		this.state.partsArray.map(part => keys.push(part.key))
		if (keys.length > 0)
			mocViewer.loadImageForBrickPalette(keys);
		keys.forEach(key => document.getElementById(key).src = mocViewer.imageURLList[key])
	}

	highLightOnClick = (key) =>
	{
		var stepInfo = mocViewer.stepInfoList[key];
		
		if(stepInfo == undefined){
			return;
		}
		
		if(key==this.state.highlightedBrickKey){
			mocViewer.highlightBricksByMeshName(false);
			this.highlightBrick(false, false);
		} else {
			if (stepInfo.page == null) {
				mocViewer.highlightBricksByMeshName(true, key);
				mocViewer.drawBoundingBox(key);
				this.highlightBrick(key, false);
			}	
		}
	}

	highlightBrick = (key, scroll) => {
		if(!key)
			this.setState({ highlightedBrickKey: '' })
		else
			this.setState({ highlightedBrickKey: key })
	}

	
}

class PagePreview extends React.Component
{
	constructor(props)
	{
		super(props)
		this.state ={
			totalPages: this.props.mocViewer.pageManager.pageList.length,
			goToPage: 0
		}
	}

	render(){
		let arrPages = []
		for(var index = 1; index < this.state.totalPages; index++){
			var page = this.props.mocViewer.pageManager.pageList[index];
			var isCurrent = this.props.mocViewer.pageManager.getCurrentPageIndex() == index ? true : false;
			var key = "Page#"+index;
			if(this.props.mocViewer.imageURLList[key]==null)continue;
			
			arrPages.push(<Preview key={key} 
				index={index} 
				isCurrent={isCurrent} 
				isSubmodel={page.grandParentPartSpec!=null} 
				image={this.props.mocViewer.imageURLList[key]}
				jumpToPage={this.jumpToPage}
				/>)
		}
		return(
			<div className="moc-viewer__steps-overview">
				<div className="moc-viewer__steps-overview-navigation">
					<div>
						<button className="btn btn--blank l-margin-right" onClick={() => this.props.closePagePreview()}><i className="fas fa-long-arrow-left"/></button>
						<span className="l-margin-right--sm">Jump to page</span>
						<input type="text" className="text-input text-input--sm l-margin-right--sm moc-viewer__steps-overview-input" onChange={(e)=> this.setState({goToPage: e.target.value})}/> 
						<span className="l-margin-right--sm">of {this.state.totalPages -1}</span> 
						<button className="btn btn--cta btn--tight" onClick={() => this.jumpToPage(this.state.goToPage)}>Go</button> 
					</div>
					<button className="dialogClose text--small-title" onClick={() => this.props.closeModal()}><i className="far fa-times"/></button>
				</div>
				<div id="popUpDlg" className="moc-viewer__steps-overview-items">
					{arrPages}
				</div>
			</div>
		)
	}

	jumpToPage = (index) =>
	{
		this.props.closePagePreview();
		this.props.mocViewer.showPage(parseInt(index), true);
		this.props.updateBrickPalette();
	}
}

const Preview = (props) =>
{
	return(
		<div className={'moc-viewer__steps-overview-item' + (props.isCurrent ? ' moc-viewer__steps-overview-item--active' : '') + (props.isSubmodel ? ' moc-viewer__steps-overview-item--submodel' : '')} onClick={() => props.jumpToPage(props.index)}>
			<div className='moc-viewer__steps-overview-item-internal'>
				<img className='moc-viewer__steps-overview-item-image' src={props.image}/>
			</div>
			<p className='moc-viewer__steps-overview-item-page'>{props.index}</p>
		</div>
	)
}

const ModelPart = (props) =>
{
	let stepInfo = props.stepInfo;

	if(!props.name.startsWith("Page#")) {
		return(
			<div className="moc-viewer__part-item">
				<div userdata={props.name} className="moc-viewer__part-item-internal" onClick={() => props.onClick(props.name)}>
					<div className="moc-viewer__part-item-image">
						<img src={props.src} id={props.name} className="moc-viewer__part-item-image-item"/>
					</div>
					<div className="moc-viewer__part-item-meta">
						{props.isSubmodel ? <p className="moc-viewer__part-item-meta-item moc-viewer__part-item-submodel l-margin-bottom--xs">Submodel</p> : null}
						<p className="moc-viewer__part-item-meta-item moc-viewer__part-item-count l-margin-bottom--xs">{`x${props.brickCnt}`}</p>
						<p className="moc-viewer__part-item-meta-item moc-viewer__part-item-number l-margin-bottom--xs">{stepInfo.partSpec == null ? stepInfo.desc : (props.isSubmodel ? `${stepInfo.partSpec.originalPartName}: Submodel` : `${getPartName(stepInfo.partSpec.originalPartName)}: ${stepInfo.partSpec.desc}`)}</p>
						{stepInfo.partSpec == null || props.isSubmodel ? null : <div className="l-flex l-center l-center-v moc-viewer__part-item-meta-item moc-viewer__part-item-swatch"><i className="color-swatch color-swatch--small l-margin-right--sm" style={{backgroundColor:`#${BRIGL_MATERIALS()[BRIGL_MATERIALS_MAPPING[stepInfo.colorIndex]].color.getHexString()}`}}/><small>{BRIGL_COLOR_NAME[stepInfo.colorIndex]}</small></div>}
					</div>
				</div>
			</div>
		)
	}else{
		return(
			<div className="moc-viewer__part-item">
				<div className="moc-viewer__part-item-internal">
					<img src={props.src} id={props.name}></img>
				</div>
			</div>
		)
	}	
}

function getPartName(partName)
{
	var name = partName
	if(name.length >=4 && name.substr(name.length-4)==".dat"){
		name = name.substr(0, name.length-4);
	} 
	return name;
}